import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import {useDispatch, useSelector} from "react-redux";
import { useParams } from 'react-router-dom';
import { getDriverById } from "../../reducers/driverReducer";
import Loading from "./Loading";
import { getReportByIdShortUrl } from "../../reducers/reportReducer";
import useRudderStackAnalytics from "../../config/useRudderAnalytics";
export default function Layout(){
    const useRudderAnalytics=useRudderStackAnalytics();
    const driverStatus=useSelector(state=>state.driver.status);
    const reportStatus=useSelector(state=>state.report.status);
    const runStatus=useSelector(state=>state.run.status);
    const vehicleStatus=useSelector(state=>state.vehicle.status);
    const whsStatus=useSelector(state=>state.whs.status);
    const currDriver=useSelector(state=>state.driver.entities.currDriver);
    const [serverStatus,setServerStatus]=React.useState("idle");
    const currReport=useSelector(state=>state.report.entities.currReport);
    const dispatch=useDispatch()
    const navigate=useNavigate()
    const location=useLocation();
    const {id}=useParams();
    React.useLayoutEffect(()=>{
        if(location.pathname.toLowerCase().includes("rl") && useRudderAnalytics){
            dispatch(getReportByIdShortUrl({
                reportId:location.pathname.split("/")[2]
            }))
            useRudderAnalytics.page("Short Link")
        }
    },[dispatch, location.pathname, useRudderAnalytics])
    React.useEffect(()=>{
        if(currReport.driverId && currReport.date && location.pathname.includes("rl")){
            navigate(`/${currReport.driverId}/haccp/report/${currReport.date}`)
        }
    },[currReport, navigate, location.pathname])
    var cookieDriverId=""
    document.cookie.split(";").map(el=>{
        if(el.split("=")[0].trim()==="driverId") cookieDriverId=el.split("=")[1]
        return el;
    })
    React.useEffect(()=>{
        if(id){
            const expireDate = new Date();
            expireDate.setFullYear(expireDate.getFullYear() + 10);
            document.cookie = `driverId=${id}; path=/; expires=${expireDate.toUTCString()}; Secure; SameSite=Lax`;
        }
        if(!id && cookieDriverId && !location.pathname.includes("rl")){
            navigate(`/${cookieDriverId}`)
        }
    },[id, cookieDriverId, navigate, location.pathname])
      React.useEffect(()=>{
          if(id){
            dispatch(getDriverById({id}));
          }
      },[id, dispatch])
    React.useEffect(()=>{
        if(driverStatus==="pending"||reportStatus==="pending"||runStatus==="pending"||vehicleStatus==="pending"||whsStatus==="pending"){
            setServerStatus("pending")
        }
        else{
            setServerStatus("idle")
        }
    },[driverStatus,reportStatus,runStatus,vehicleStatus, whsStatus])
    React.useEffect(()=>{
        if(currDriver && currDriver.driverId && useRudderAnalytics){
            useRudderAnalytics.identify(currDriver.driverId,currDriver);
        }
    }, [currDriver, useRudderAnalytics])
    return (
        <div style={{height:"100%"}}>
            {serverStatus==="pending"&&<Loading/>}
            <Navbar/>
            <div style={{marginTop:"90px"}}>
                <Outlet/>
            </div>
            
        </div>
    )
}